import React, { forwardRef } from 'react';
import { Translate } from '@/components';
import { cx } from '@emotion/css';
import styles from './Tag.styles';

export type TagVariantType =
  | 'startDate'
  | 'deadline'
  | 'outline'
  | 'new'
  | 'greyOutline'
  | 'expired'
  | 'timeline'
  | 'filled'
  | 'viewed'
  | 'beta'
  | 'community'

export interface Props {
  children: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClick?: () => void;
  variant: TagVariantType;
}

export const Tag = forwardRef<HTMLDivElement, Props>(({
  children,
  onClick,
  leftIcon,
  rightIcon,
  variant,
}, ref) => (
  <div ref={ref} className={cx(styles.tag, styles.variants[variant])} onClick={onClick}>
    {leftIcon}
    <Translate>{children}</Translate>
    {rightIcon}
  </div>
));

Tag.displayName = 'Tag';
